import { initializeApp, getApps } from 'firebase/app';
import { getAuth, browserSessionPersistence, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase only if it hasn't been initialized
let app;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Function to get logo URL
export const getLogoUrl = async () => {
  try {
    const storageRef = ref(storage, 'assets/logo.png');
    const url = await getDownloadURL(storageRef);
    return url;
  } catch (error) {
    console.error('Error getting logo URL:', error);
    // Fallback to a default hosted image URL
    return process.env.REACT_APP_FALLBACK_LOGO_URL || 'https://firebasestorage.googleapis.com/v0/b/ccro-acc09.appspot.com/o/assets%2Flogo.png?alt=media';
  }
};

// Set auth persistence
setPersistence(auth, browserSessionPersistence).catch(console.error);

export default app;
